export default __webpack_public_path__ + "static/media/sitcom-laughter-with-applause.da6c40af.mp3";